var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { handleSupabaseError } from "@cloudy/utils/common";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "src/api/queryClient";
import { projectQueryKeys } from "src/api/queryKeys";
import { supabase } from "src/clients/supabase";
import { useWorkspace } from "src/stores/workspace";
export var makeProjectHomeUrl = function (wsSlug, projectSlug) {
    return "/workspaces/".concat(wsSlug, "/projects/").concat(projectSlug);
};
export var makeProjectSettingsUrl = function (wsSlug, projectSlug) {
    return "/workspaces/".concat(wsSlug, "/projects/").concat(projectSlug, "/settings");
};
export var makeNewProjectUrl = function (wsSlug) {
    return "/workspaces/".concat(wsSlug, "/projects/new");
};
export var useEditProject = function () {
    var workspace = useWorkspace();
    return useMutation({
        mutationFn: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
            var updateObject, updatedProject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updateObject = {};
                        if (payload.name)
                            updateObject.name = payload.name;
                        if (payload.slug)
                            updateObject.slug = payload.slug;
                        return [4 /*yield*/, supabase
                                .from("projects")
                                .update(updateObject)
                                .eq("id", payload.projectId)
                                .select()
                                .single()];
                    case 1:
                        updatedProject = _a.sent();
                        return [2 /*return*/, handleSupabaseError(updatedProject)];
                }
            });
        }); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [workspace.slug, "projects"] });
        },
    });
};
export var useProjectRepos = function (projectId) {
    return useQuery({
        queryKey: projectQueryKeys.repos(projectId),
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!projectId)
                            return [2 /*return*/, []];
                        _a = handleSupabaseError;
                        return [4 /*yield*/, supabase.from("repository_connections").select("*").eq("project_id", projectId)];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        }); },
    });
};
